import { useQuery } from '@tanstack/react-query';
import { fetchPaymentTypeCodes } from '../../utils/apiUtils';

const HrpPaymentTypeCode = ({ paymentTypeKey }) => {

    const { data, isLoading, error } = useQuery({
        queryKey: ['paymentTypeKey', paymentTypeKey],
        queryFn: async () => {
            const result = await fetchPaymentTypeCodes();
            return result;
        },
        // select: (data) => data[0],
        staleTime: Infinity,
        enabled: true
    });
    const paymentType = data?.find(r => r.paymentTypeKey === paymentTypeKey)
    return (
        <>
            {paymentTypeKey}
            <br />
            {paymentType && `
            ${paymentType?.paymentTypeName} 
            `}
            {isLoading && 'Loading...'}
            {error && <p className='danger'>{error.messsage}</p>}</>
    )
}

export default HrpPaymentTypeCode